<template>
  <div class="slider-multiple home-section">
    <div
      :class="{
        domainbasedHeight: domainBasedBrand,
        offerheight: offers.length < 1,
      }"
    >
      <div class="home-slider">
        <div class="container">
          <div class="row">
            <div class="col-12 ratio_square">
              <h3>{{_T('Offers')}}</h3>
            </div>
          </div>

          <div class="row">
            <div class="col-12 ratio_square">
              <div class="home-slider-4 default-arrow slider-space row">
                <OfferTile
                  class="offer-slide col-lg-3 col-md-6 col-sm-12"
                  :offer="offer"
                  v-for="offer in offers"
                  :key="offer.id"
                  @click.native="OfferData(offer)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <store-picker />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import OfferTile from '@/components/Collections/OfferTile'
import StorePicker from '@/components/Collections/StorePicker'
import Windowsize from '@/mixins/Windowsize'

export default {
  name: 'OfferPage',
  props: ['offers'],
  components: { OfferTile, StorePicker },
  mixins: [Windowsize],
  computed: {
    ...mapGetters(['_T', 'domainBasedBrand']),
  },
  data () {
    return {
      breakpointsRatio: 1199, //in future will add by windows.width
      swiperOptions: {
        slidesPerView: 4,
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        loop: false,
        // initialSlide: 0,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        speed: 1000,
        // direction: 'horizontal',
        // grabCursor: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          1199: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
          991: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          576: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          460: {
            loop: true,
            centeredSlides: true,
            slidesPerView: 2,
            spaceBetween: 20,
            navigation: true,
            pagination: true,
          },
          320: {
            centeredSlides: true,
            slidesPerView: 1,
            spaceBetween: 20,
            navigation: true,
            pagination: true,
          },
        },
      },
    }
  },
  methods: {
    OfferData (offer) {
      this.$store.commit('SET_SELECTED_BRAND', offer.brand_id)
      this.$store.commit('SET_SELECTED_OFFER', offer)
      //   if(this.brandWiseStores.length ==1) {
      //   this.$router.replace({
      //     name: this.brandStoreRoute('store_page'),
      //     params:
      //       this.brandStoreParams
      //   })
      // }
      // else {
      this.$bvModal.show('storepicker-id')
      // }
    },
  },
}
</script>

<style lang="scss" scoped>
h3 {
  color: var(--color-font-color);
  text-transform: capitalize;
  margin-bottom: 0;
  -webkit-transition: all 0.5s ease;
  transition: all 0.5s ease;
  margin-top: 30px;
  margin-bottom: 10px;
}

@media (max-width: 575px) {
  .offer-slide {
    padding: 20px 20px 10px 20px;
  }
  .offer-slide:last-child {
    padding: 20px 20px 100px 20px;
  }

  h3 {
    margin-top: 14px;
    color: var(--color-font-color);
    margin-bottom: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    font-weight: bold;
    font-size: 1rem;
    line-height: 1.1875rem;
  }

  .home-section {
    border-top: 0.75rem solid var(--color-light-border);
  }
}

.bg-img {
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  display: block;
}
.home {
  height: $px600;
  &.offerheight {
    height: $px230;
  }
  .home-slider-4 {
    margin-left: -$px15;
    margin-right: -$px15;
    &.row {
      justify-content: center;
    }
    .swiper-container {
      padding: 0 $px15;
      overflow-x: hidden;
      overflow-y: hidden;
      .swiper-button-prev,
      .swiper-button-next {
        width: $px50;
        height: $px50;
        background-color: $white;
        border-radius: 100%;
        box-shadow: 0px $px4 $px10 rgba($black, 0.25);
        left: 0;
        top: 39%;
        z-index: 9;
        &.swiper-button-disabled {
          opacity: 0;
        }
        &:after {
          content: '';
          background-image: url('/images/svg/global/right-arrow-1.svg');
          color: $white;
          opacity: 1;
          position: absolute;
          left: 50%;
          top: 50%;
          -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
          width: $px16;
          height: $px16;
        }
      }
      .swiper-button-prev {
        &:after {
          transform: scaleX(-1);
          top: $px17;
          left: $px17;
        }
      }
      .swiper-button-next {
        left: unset;
        right: 0;
      }
      .swiper-pagination-bullets {
        bottom: 0;
        color: $white;
        .swiper-pagination-bullet {
          color: red;
        }
      }
    }
  }
}
// .domainbasedHeight {
//   height: $px560 !important;
// }
.slider-title {
  margin-top: $px35;
  text-align: center;
  h2 {
    color: $white;
    font-weight: bold;
    text-transform: capitalize;
    a {
      display: none;
    }
  }
  h6 {
    color: $white;
    margin-bottom: -$px4;
  }
}
@media (max-width: 991px) {
  .home {
    .home-slider-4 {
      .swiper-container {
        .swiper-button-prev,
        .swiper-button-next {
          width: $px35;
          height: $px35;
        }
        .swiper-button-prev {
          &:after {
            top: $px10;
            left: $px11;
          }
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .home {
    height: $px470;
    &.offerheight {
      height: $px470;
    }
  }
}
@media (max-width: 575px) {
  .home {
    &.offerheight {
      height: auto;
    }
    height: auto;
    background-image: none !important;
    .home-slider {
      display: flex;
      align-items: center;
      justify-content: center;
      height: auto;
      padding: $px15 0;
      .swiper-pagination {
        display: none;
      }
    }
    .swiper-button-prev,
    .swiper-button-next {
      display: none;
    }
  }
  .slider-title {
    margin-top: 0;
    h2 {
      color: $font-color;
      margin-bottom: 0;
      display: flex;
      align-items: center;
      font-weight: bold;
      font-size: $px16;
      line-height: $px19;
      a {
        display: block;
        font-weight: 600;
        font-size: $px13;
        line-height: $px16;
        letter-spacing: 0.02em;
        color: $color-primary;
        margin-left: auto;
      }
    }
    h6 {
      display: none;
    }
  }
}
</style>
